<h1 mat-dialog-title>{{ data.titel }}</h1>
<div mat-dialog-content>
  <p>{{ data.frage }}</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">{{ data.abbrechenText }}</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>{{ data.okText }}</button>
</div>
